import React from "react";

const ShoppingCartHelper = ({ txt }) => {
  return <div className="shoppingHeaderCart">{txt}</div>;
};

export default ShoppingCartHelper;
